import React from "react";
import registrationOnlyMode from "../../hooks/registrationOnlyMode";
import Divider from "../divider";
import { LoginForm } from "../forms";

const LoginSection = () => {
  const registrationOnly = registrationOnlyMode();

  return (
    <>
      {registrationOnly || (
        <>
          <h2>Already Registered?</h2>
          <LoginForm />
          <Divider />
        </>
      )}
    </>
  );
};

export default LoginSection;
